import { useMemo } from 'react';
import { FREE_EDITION } from '@jira/platform__application-editions/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const useIsJswFreeEdition = () => {
	const appEditions = useAppEditions();
	return useMemo(() => appEditions.software === FREE_EDITION, [appEditions]);
};
